// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloseSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PCloseSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloseSquareOutlined = function PCloseSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloseSquareOutlinedSvg
  }));
};

PCloseSquareOutlined.displayName = 'PCloseSquareOutlined';
export default React.forwardRef(PCloseSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloseSquareOutlined.js
// module id = 3285
// module chunks = 0